import { render, staticRenderFns } from "./ArtworkForm.vue?vue&type=template&id=13698692&scoped=true&"
import script from "./ArtworkForm.vue?vue&type=script&lang=js&"
export * from "./ArtworkForm.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkForm.vue?vue&type=style&index=0&id=13698692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13698692",
  null
  
)

export default component.exports